'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var object_filled_keys_count = require('../helpers/object-filled-keys-count');
var is_valid_moment_object = require('../helpers/is-valid-moment-object');
var filterByCustomFilters = require('../filters/custom-filters');

module.exports = function (data, e) {

  if (e && e === 'multi') this.setPage(1, true);

  if (e && e !== 'multi') {

    var _query = this.query;

    this.setPage(1, true);

    var name = this.getName(e.target.name);
    var value = _typeof(e.target.value) === 'object' ? e.target.value : '' + e.target.value;

    if (name) {
      _query[name] = value;
    } else {
      _query = value;
    }

    this.vuex ? this.commit('SET_FILTER', _query) : this.query = _query;

    this.updateState('query', _query);

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch('filter::' + name, value);
    } else {
      this.dispatch('filter', value);
    }
  }

  var query = this.query;

  var totalQueries = !query ? 0 : 1;

  if (!this.opts) return data;

  if (this.opts.filterByColumn) {
    totalQueries = object_filled_keys_count(query);
  }

  var value;
  var found;
  var currentQuery;
  var dateFormat = this.opts.dateFormat;
  var filterByDate;
  var isListFilter;
  var isMulti;

  var data = filterByCustomFilters(data, this.opts.customFilters, this.customQueries);

  if (!totalQueries) return data;

  return data.filter(function (row, index) {

    found = 0;

    this.filterableColumns.forEach(function (column) {

      filterByDate = this.opts.dateColumns.indexOf(column) > -1 && this.opts.filterByColumn;

      isListFilter = this.isListFilter(column) && this.opts.filterByColumn;

      isMulti = this.opts.multiColumns.hasOwnProperty(column);

      value = getValue(row[column], filterByDate, dateFormat);

      currentQuery = this.opts.filterByColumn ? query[column] : query;

      currentQuery = setCurrentQuery(currentQuery, isMulti);

      var c = multipleMatch(currentQuery, value, isListFilter, isMulti);

      found += c;
    }.bind(this));

    return found >= totalQueries;
  }.bind(this));
};

function multipleMatch(currentQuery, value, isListFilter, isMulti) {

  var c = 0;

  for (var ix in currentQuery) {

    var q = currentQuery[ix];
    if (q && foundMatch(q, value, isListFilter, isMulti)) {
      return 1;
    }
  }

  return 0;
}

function setCurrentQuery(query, isMulti) {

  if (!query) return [''];

  if (typeof query === 'string') query = query.toLowerCase().split(',');
  return query;

  if (isMulti) return query;
  // Date Range

  return [query];
}

function foundMatch(query, value, isListFilter, isMulti) {

  // List Filter
  if (isListFilter || isMulti) return value == query;

  // Text Filter
  if (typeof value == 'string') return value.indexOf(query) > -1;

  // Date range

  var start = moment(query.start, 'YYYY-MM-DD');
  var end = moment(query.end, 'YYYY-MM-DD');

  return value >= start && value <= end;
}

function getValue(val, filterByDate, dateFormat) {

  if (is_valid_moment_object(val)) {

    if (filterByDate) return val;
    return val.format(dateFormat);
  }

  return String(val).toLowerCase();
}


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/client-search.js